import styled from '@emotion/styled'
import { Container, Grid } from '@mui/material'
import React from 'react'
import logo from "../../assets/img/logo.png"
import twitter from "../../assets/img/twitter.png"
import telegram from "../../assets/img/telegram.png"
import MenuDropdown from './MenuDropdown'
import { SocialImg } from '../../styles'
import { telegramLink, twitterLink } from '../../pages/config'

const MenuWrapper = styled.div`
    background-color: #C20D00;
    padding: 20px;
`
const LogoImg = styled.img`
    width: 100%;
    max-width: 180px;
    height: auto;
`
const GridEx = styled(Grid)`
    display: flex;
    justify-content: flex-end;
    align-items: center;
`
const SocialLinks = styled.a`
    @media (max-width: 600px){ display: none; }
`

const Menu = () => {
  return (
    <MenuWrapper>
        <Container maxWidth="xl">
            <Grid container>
                <Grid xs={7} sm={6} item sx={{textAlign: 'left'}}>
                    <a href="/">
                        <LogoImg src={logo} alt="Logo" />
                    </a>
                </Grid>
                <GridEx xs={5} sm={6} item>
                    <SocialLinks href={twitterLink} target='_blank'>
                        <SocialImg src={twitter} alt="twitter-logo" />
                    </SocialLinks>
                    <SocialLinks href={telegramLink} target='_blank'>
                        <SocialImg src={telegram} alt="telegram-logo" />
                    </SocialLinks>
                    <MenuDropdown />
                </GridEx>
            </Grid>
        </Container>
    </MenuWrapper>
  )
}

export default Menu